// this file is generated by update_shopify_store_data.py at 2025-12-03 20:27:56.287060
var courses = [];